import {Component, HostBinding, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {LocalStorageService} from './local-storage.service';
import {VinavonUpdateService} from './services/vinavon-update.service';
import {MatIconRegistry} from '@angular/material/icon';
import {DomSanitizer} from '@angular/platform-browser';
import {UserAuthenticationService} from './services/user-authentication.service';
import {HelperService} from './services/helper.service';
import {DataService} from './time-app/services/data.service';
import {environment} from '../environments/environment';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
    @HostBinding('class.isMobileNative') isMobileNative = false;

    constructor(
        public userAuthService: UserAuthenticationService,
        private translate: TranslateService,
        private localStorage: LocalStorageService,
        private svcVinavonUpdate: VinavonUpdateService,
        private matIconRegistry: MatIconRegistry,
        private domSanitizer: DomSanitizer,
        private helperService: HelperService,
        private dataService: DataService,
    ) {
        this.matIconRegistry.addSvgIcon('ss-logo', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/swiss-soft-logo_zentriert_black.svg'));
        this.localStorage.setUpService(this.userAuthService, this.svcVinavonUpdate).then(() => this.dataService.getDbDataLoaded().next(true));

        if (environment.isMobile) {
            this.isMobileNative = true;
            document.body.classList.add('isMobileNative');
        }

        // Update-Prüfung: ab jetzt wird in einem Intervall geprüft, ob ein neues Update vorhanden ist.
        if (!environment.isMobile) {
            this.helperService.addPeriodicalCheck(this.svcVinavonUpdate.startCheckUpdateInterval.bind(this.svcVinavonUpdate));
        }

        /* Ab jetzt Login regelmässig prüfen, ob die Lizenz noch vorhanden ist. */
        this.helperService.addPeriodicalCheck(this.userAuthService.startCheckLoginState.bind(this.userAuthService));
        // this language will be used as a fallback when a translation isn't found in the current language
        this.translate.setDefaultLang('de');

        this.localStorage.get('language', 'SwissTimeEntry', true, 'de').then(async (res: any) => {
            await this.localStorage.add('language', res, 'SwissTimeEntry', false, true);
            this.translate.use(res);
        });
    }

    async ngOnInit(): Promise<void> {
        await this.helperService.loadOrGenSessionGuid();
        await this.helperService.updateTranslations();
        this.userAuthService.getCurrentUser().subscribe({
            next: async (user) => {
                if (!user) {
                    await this.helperService.loadOrGenSessionGuid();
                }
            }
        });
    }
}
